import { getXhr, log, transformHeader } from './util'

const defaultConfig = {
  range: '0-1048576',
  timer: 60 * 1000,
  timeout: 15000
}

export default class SpeedCheckTask {
  constructor (options = {}) {
    Object.keys(defaultConfig).map(key => {
      if (options[key] === undefined || options[key] === null) {
        options[key] = defaultConfig[key]
      }
    })
    this.options = options
    this._headers = {}
    // this.speed = 0
    this.intervalId = null
    this.ishangUp = false
    this._data = {
      contentLength: 0,
      statusText: '',
      status: -1,
      speed: 0,
      costTime: 0,
      connectTime: 0,
      contentType: ''
    }
    this.url = []
  }

  setData (data, url) {
    Object.keys(data).map(key => {
      if (key !== 'headers') {
        this._data[key] = data[key]
      }
    })
    if (data.headers && Object.keys(data.headers).length > 0) {
      this._headers = transformHeader(data.headers)
      data.headers['content-type'] && (this._data.contentType = data.headers['content-type'])
      const resrange = data.headers['content-range'] || ''
      const arr = resrange.split('/')
      if (arr && arr.length > 1) {
        this._data.contentLength = parseInt(arr[1])
      }
    }
  }

  get contentLength () {
    return this._data.length || 0
  }

  trigger (url, type = 'start') {
    const { options } = this
    this.url = url
    if (this.url && (type === 'start' || (!this.ishangUp && !this.intervalId))) {
      log('task>>trigger url ', url)
      this.ishangUp = true
      this.intervalId && this.clear()
      this.intervalId = setTimeout(() => {
        this.clear()
      }, type === 'start' ? 500 : options.timer)
      getXhr(this.url, { range: type === 'start' ? '0-1024' : options.range, timeout: options.timeout }).then((data) => {
        log('getXhr>>check result ', data)
        this.setData(data || {})
        this.ishangUp = false
      }).catch((e) => {
        log('getXhr>>error ', e)
        this.ishangUp = false
        this._data.status = -1
      })
    } else {
      log('task>>cant`t trigger url', this.ishangUp, this.intervalId)
    }
  }

  set url (value) {
    value && (this.options.url = value)
  }

  get url () {
    return this.options.url
  }

  get serverIp () {
    return this._headers.x_response_sinfo || ''
  }

  get headers () {
    return this._headers || {}
  }

  get status () {
    return this._data.status || -1
  }

  get speed () {
    return this._data.speed
  }

  clear () {
    clearTimeout(this.intervalId)
    this.intervalId = null
  }
}
